export const nav = {
    permissao: 'hdocs.categorias:ver',
    section: 'Configuracao',
    title: 'Categorias',
    icon: 'category',
    route: '/categorias',
    // A ordem das SECOES no menu sai de qual nav, entre TODOS os modulos, tem
    // a menor sequence (ver montarMenu em menuDosModulos.js -- a secao nasce
    // na primeira vez que aparece nesse ranking global, nao por secao). Os
    // itens de "Documentos" usam 1-2; aqui comeca em 10 para garantir que
    // "Configuracao" sempre nasce depois, ficando por ultimo no menu.
    sequence: 10,
};

export default [
    {
        path: '/categorias',
        name: 'categorias',
        component: () => import('./pages/CategoriasPage.vue'),
        meta: { requiresAuth: true, permissao: 'hdocs.categorias:ver' },
    },
];
